import { render } from "./postMan.vue?vue&type=template&id=66bd3dbf&scoped=true"
import script from "./postMan.vue?vue&type=script&lang=js"
export * from "./postMan.vue?vue&type=script&lang=js"

import "./postMan.vue?vue&type=style&index=0&id=66bd3dbf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66bd3dbf"]])

export default __exports__